import { ServicesGrid, TrustSection } from "@/components/ServicesAndTrust";
import BrandStamp from "@/components/BrandStamp";

export default function ServicesPage() {
  return (
    <div>
      <section className="bg-[#2D181A] text-[#FFFDF8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold">
            Services · सेवाएं
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-[1.02] max-w-4xl">
            Three specialist services.{" "}
            <span className="italic text-[#D4AF37]">One promise</span> — the
            best rate for your gold.
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#FFFDF8]/80 leading-relaxed max-w-3xl">
            From instant cash to complex bank settlements and certified
            valuations — Top Rate handles every gold transaction with the same
            transparency.
          </p>
        </div>
      </section>
      <BrandStamp variant="gold" tagline={<>Instant Cash · Mortgage Buyback · Govt. Valuation</>} />
      <ServicesGrid compact />
      <BrandStamp variant="dark" tagline={<>Sona Do Paisa Lo · No Manipulation</>} />
      <TrustSection />
    </div>
  );
}
